import {
	createStyles,
	makeStyles,
	Theme,
	withStyles,
} from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React from "react";
import {FONTS, HIST_CHART_SELECTED, SECONDARY_COLOR} from "../../constants";
import {stateType} from "../../state";
import {calcCatHistData, CatDropDown} from "../DataIngestion/CatDropDown";
import {calcNumericHistData} from "../DataIngestion/DistributionBox";
import {NumericDropDown} from "../DataIngestion/NumericDropdown";

const useStyles = makeStyles((theme: Theme) => ({
	root: {
		flexGrow: 1,
		zIndex: 1000,
	},
	padding: {
		padding: theme.spacing(3),
	},
	demo1: {
		backgroundColor: "white",
		borderRadius: "10px",
	},
	dropDown: {
		marginRight: "20px",
		marginTop: "10px",
		marginLeft: "auto",
	},
}));

export function TableTabs({state}: stateType) {
	const classes = useStyles();
	const [value, setValue] = React.useState(0);

	const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
		state.saveState.dataUpload.histTabSelected = newValue;
		state.setSaveState(state.saveState);
		setValue(newValue);
		if (newValue === 1) {
			calcCatHistData(state);
		} else {
			calcNumericHistData(state);
		}
	};

	function SelectedChart() {
		const selected = state.saveState.dataUpload.histTabSelected;
		if (selected === HIST_CHART_SELECTED.num) {
			return <NumericDropDown state={state}></NumericDropDown>;
		} else {
			return <CatDropDown state={state}></CatDropDown>;
		}
	}

	return (
		<div className={classes.root}>
			<div className={classes.demo1}>
				<Tabs
					value={state.saveState.dataUpload.histTabSelected}
					onChange={handleChange}
					indicatorColor={"primary"}
					aria-label="ant example"
				>
					<Tab
						label="&emsp;&emsp;Numeric"
						style={{fontFamily: FONTS}}
					/>
					<Tab label="Categorical" style={{fontFamily: FONTS}} />
					<div className={classes.dropDown}>{SelectedChart()}</div>
				</Tabs>
			</div>
		</div>
	);
}
